// extracted by mini-css-extract-plugin
export default {"logo_container":"Logo_logo_container__cfB2m"};